export const mergeById = <T extends { id: string }>(current: T[], updates: T[]): T[] => {
  const byId = new Map(current.map((entry) => [entry.id, entry]))
  updates.forEach((entry) => byId.set(entry.id, entry))

  return Array.from(byId.values())
}

/** Keep deleted registry entries out of the local view, including stale parent props or earlier edits. */
export const mergeRecipientContactPoints = (
  current: ContactPoint[],
  updates: ContactPoint[],
  deletedContactPointIds: readonly string[],
): ContactPoint[] => {
  const deletedIds = new Set(deletedContactPointIds)

  return mergeById(current, updates).filter((point) => !deletedIds.has(point.id))
}

export const workOrdersForRecipientScope = (
  workOrders: WorkOrder[],
  workOrder: WorkOrder,
  changedCustomerIds: readonly string[] = [],
) => {
  const unitId = `${workOrder.property_unit_id ?? ""}`
  const customerIds = new Set(changedCustomerIds)
  const matching = workOrders.filter(
    (entry) =>
      (entry.property_id === workOrder.property_id &&
        `${entry.property_unit_id ?? ""}` === unitId) ||
      entry.recipients?.some((recipient) => customerIds.has(recipient.customer_id)),
  )

  return matching.length ? matching : [workOrder]
}
